<template>
  <!-- Disabled entries render inert (e.g. "Coming soon" items) -->
  <div v-if="disabled" class="-m-3 p-3 flex items-start rounded-md opacity-50 cursor-not-allowed">
    <div v-if="$slots.icon" class="flex-shrink-0 text-gray-400 text-lg leading-6 mr-3">
      <!-- @slot Optional icon shown to the left of the title. -->
      <slot name="icon" />
    </div>
    <div>
      <p class="text-base leading-6 font-medium text-gray-900 m-0" :class="titleClass">
        {{ title }}
      </p>
      <p class="text-sm leading-5 text-gray-500 m-0">
        <slot />
      </p>
    </div>
  </div>

  <!-- External links (target="_blank") for destinations outside the SPA -->
  <a
    v-else-if="href"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    class="-m-3 p-3 flex items-start rounded-md transition ease-in-out duration-150 hover:bg-indigo-50"
    @click="$emit('click')"
  >
    <div v-if="$slots.icon" class="flex-shrink-0 text-indigo-500 text-lg leading-6 mr-3">
      <slot name="icon" />
    </div>
    <div>
      <p class="text-base leading-6 font-medium text-gray-900 m-0" :class="titleClass">
        {{ title }}
      </p>
      <p class="text-sm leading-5 text-gray-500 m-0">
        <slot />
      </p>
    </div>
  </a>

  <router-link v-else :to="target" @click="$emit('click')" class="-m-3 p-3 flex items-start rounded-md transition ease-in-out duration-150 hover:bg-indigo-50">
    <div v-if="$slots.icon" class="flex-shrink-0 text-indigo-500 text-lg leading-6 mr-3">
      <slot name="icon" />
    </div>
    <div>
      <p class="text-base leading-6 font-medium text-gray-900 m-0" :class="titleClass">
        {{ title }}
      </p>
      <p class="text-sm leading-5 text-gray-500 m-0">
        <!-- @slot Let's you pass a string or html as the menu item's description. -->
        <slot />
      </p>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    /**
     * Used to specify the menu's title.
     */
    title: {
      type: String,
      default: 'Link Title'
    },
    /**
     * Specify CSS classes to apply to the title (like a color or uppercase).
     */
    titleClass: {
      type: String,
      default: ''
    },
    /**
     * Sets the URL for this menu item.
     */
    target: {
      type: String,
      default: '/'
    },
    /**
     * External URL — renders a plain anchor with target="_blank" instead of a router-link.
     */
    href: {
      type: String,
      default: null
    },
    /**
     * Renders the item inert (no link, dimmed) — e.g. "Coming soon" entries.
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click']
}
</script>

<style></style>
